import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm?: () => void;
  showConfirmButton?: boolean;
  confirmText?: string;
  cancelText?: string;
  disabled?: boolean;
}

export default function ConfirmationDialog({
  open,
  title,
  message,
  onClose,
  onConfirm,
  showConfirmButton = true,
  confirmText = "Confirmar",
  cancelText = "Voltar",
  disabled = false,
}: ConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "5px",
          width: "469px",
          height: "438px",
          padding: "40px",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 20, right: 20, cursor: "pointer" }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <DialogTitle sx={{ color: "#4D4D4D", fontWeight: 500 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ marginTop: "30px" }}>
        <DialogContentText
          sx={{ whiteSpace: "pre-line", textAlign: "center", margin: "0 auto" }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      {showConfirmButton && (
        <DialogActions>
          <Button
            onClick={onConfirm}
            disabled={disabled ?? false}
            sx={{
              width: "300px",
              height: "42px",
              background: "#007085",
              color: "#fff",
              fontWeight: 600,
              textTransform: "uppercase",
              borderRadius: "8px",
              "&:hover": {
                background: "#0071856b",
              },
            }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      )}

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            width: "300px",
            height: "42px",
            background: "#fff",
            border: "solid 2px #007085",
            color: "#007085",
            fontWeight: 600,
            borderRadius: "8px",
            "&:hover": {
              background: "#00718525",
            },
          }}
        >
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
